import React from 'react';
import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/auth/ProtectedRoute';
import CommunityRoute from '../components/auth/CommunityRoute';
import LessonsRoute from '../components/auth/LessonsRoute';
import LazyRoute from '../components/helpers/LazyRoute';
import AlunaLayout from '../components/aluna/layout/AlunaLayout';

import BoasVindas from '../pages/aluna/comece/BoasVindas';
import ContentPage from '../pages/aluna/aulas/ContentPage';

import {
  Apresentacao,
  ChapterOverview,
  AulasPlaylist,
  Indicacoes,
  Relacionamento,
  Sonhos,
  Trabalho,
  Desabafo,
  AssuntosGerais,
  Capitulos,
  Shop,
  PostPage,
  Configuracoes,
  MyCommunities,
  Home,
  SalaDeEspera,
  GirlsPlaining,
  Avisos
} from '../utils/lazyImports';

export const AlunaRoutes = (
  <>
    {/* ROTAS DA ÁREA DA ALUNA */}
    <Route
      path="/aluna/:courseId/"
      element={
        <ProtectedRoute>
          <AlunaLayout />
        </ProtectedRoute>
      }
    >
      <Route index element={<LazyRoute><Home /></LazyRoute>} />
      <Route path="configuracoes" element={<LazyRoute><Configuracoes /></LazyRoute>} />

      {/* Comece por aqui */}
      <Route path="comece/boas-vindas" element={<BoasVindas />} />
      <Route path="comece/apresentacao" element={<LazyRoute><Apresentacao /></LazyRoute>} />

      {/* Aulas — protegidas por LessonsRoute */}
      <Route element={<LessonsRoute />}>
        <Route path="aulas" element={<LazyRoute><AulasPlaylist /></LazyRoute>} />
        <Route path="aulas/:moduleId" element={<LazyRoute><AulasPlaylist /></LazyRoute>} />
        <Route path="aulas/capitulo/:chapterId" element={<LazyRoute><ChapterOverview /></LazyRoute>} />
        <Route path="aulas/capitulo/:chapterId/:contentType" element={<ContentPage />} />
      </Route>

      {/* Debates — protegidos por CommunityRoute */}
      <Route element={<CommunityRoute />}>
        <Route path="debates/indicacoes" element={<LazyRoute><Indicacoes /></LazyRoute>} />
        <Route path="debates/relacionamento" element={<LazyRoute><Relacionamento /></LazyRoute>} />
        <Route path="debates/sonhos" element={<LazyRoute><Sonhos /></LazyRoute>} />
        <Route path="debates/trabalho" element={<LazyRoute><Trabalho /></LazyRoute>} />
        <Route path="debates/desabafo" element={<LazyRoute><Desabafo /></LazyRoute>} />
        <Route path="debates/assuntos-gerais" element={<LazyRoute><AssuntosGerais /></LazyRoute>} />
        <Route path="debates/capitulos" element={<LazyRoute><Capitulos /></LazyRoute>} />
        <Route path="debates/sala-de-espera" element={<LazyRoute><SalaDeEspera /></LazyRoute>} />
        <Route path="debates/girlsplaining" element={<LazyRoute><GirlsPlaining /></LazyRoute>} />
        <Route path="posts/:postId" element={<LazyRoute><PostPage /></LazyRoute>} />
      </Route>

      {/* Shop */}
      <Route path="shop" element={<LazyRoute><Shop /></LazyRoute>} />

      {/* Avisos */}
      <Route path="avisos" element={<LazyRoute><Avisos /></LazyRoute>} />
    </Route>

    {/* ✅ ROTA FORA DA ÁREA /aluna */}
    <Route
      path="/meus-cursos"
      element={
        <ProtectedRoute>
          <LazyRoute><MyCommunities /></LazyRoute>
        </ProtectedRoute>
      }
    />
  </>
);
